import { EMPTY_LIST } from '../../../../constants/common'

export function useFormikSelectFieldGetEmptyValue({ emptyValue, multi }) {
  return emptyValue === undefined
    ? multi
      ? EMPTY_LIST
      : undefined // `undefined` needs for default value in `FormikField`
    : emptyValue
}
